<template>
	<div class="album_detail_container">
		<div v-if="detailData">

			<!-- 手机端扫码访问 -->
			<div style="width: 150px; height: 40px; position: fixed; bottom: 40px; right: 20px; z-index: 999;">
				<el-popover placement="bottom" width="200" trigger="click">

					<div
						style="display: flex;  flex-direction: column;justify-content: center; align-items: center;width: 100%; height: 200px;">
						<div ref="qrcode" style="width: 120px; height: 120px;"></div>
						<div
							style="font-size: 13px; width: 200; margin-top: 15px;display: flex;flex-direction: column; align-items: center;">
							扫码访问手机版详情页
						</div>
					</div>

					<el-button slot="reference">手机版二维码</el-button>
				</el-popover>
			</div>


			<!-- 购买提示 -->
			<el-dialog title="订阅课程" width="420px" top="28vh" :visible.sync="dialogQrVisible" :show-close="true">
				<div
					style=" width: 100%; height: 150px; display: flex; flex-direction: column;justify-content: center;align-items: center;">
					<div ref="qrcode2" style="width: 150px; height: 150px;"></div>
					<div style="margin-top: 10px;">
						请扫码二维码订阅本课程
					</div>
				</div>

				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogQrVisible = false">取消支付</el-button>
					<el-button type="primary" @click="finishedClick">支付完成</el-button>
				</div>
			</el-dialog>


			<div style="width: 100%;display: flex; flex-direction: column; align-items: center;">

				<div
					style="display: flex; justify-content: space-between; width: 1200px; background-color: #fff; margin-top: 40px; padding:30px; box-sizing: border-box; border-radius: 8px;">
					<img :src="detailData.img_url" style=" width: calc(50% - 30px) ;" />
					<div
						style="display: flex; flex-direction: column; justify-content: space-between; width: calc(50% - 30px) ;  padding-top: 15px; box-sizing: border-box;">
						<div>
							<div style="font-size: 32px; font-weight: 600; line-height: 1.2;">{{detailData.title}}</div>
							<div style="color: #999; line-height: 1.2; margin-top: 10px; text-align: justify;"
								v-html="detailData.summary"></div>
						</div>
						<div style="display: flex; width: 100%; justify-content: space-between;"
							v-if="detailData.status && detailData.status.status_code  && (detailData.status.status_code == 2 || detailData.status.status_code == 5)">
							<div class="" style="display: flex; align-items: flex-end;  color: #c83a2e;"
								v-if="detailData.price!='0.00'">
								<div style="color: #c83a2e; display: flex; align-items: flex-end;  margin-right: 10px;">
									<div style="font-size: 18px; font-weight: 600; margin-right: 5px;">特惠价</div>
									<div style="font-size: 18px;">￥</div>
									<div style="font-size: 36px;margin-bottom: -8px;">{{detailData.price}}</div>
								</div>
								<div
									style="display: flex;font-size: 18px;color: #ccc; align-items: center; text-decoration: line-through;">
									￥{{detailData.line_price}}
								</div>
							</div>

							<!-- <div class="" style="display: flex; align-items: flex-end;  color: #c83a2e;" v-if="detailData.price=='0.00'">
								<div style="color: #c83a2e; display: flex; align-items: flex-end;  margin-right: 10px;">
									<div style="font-size: 36px;margin-bottom: -8px;">免费</div>
								</div>
							</div> -->

							<div v-if="detailData.status && detailData.status.status_code && detailData.status.status_code == 2 && detailData.price!='0.00'"
								@click="showQrClick"
								style="width: 200px;height: 60px;display:inline-flex;background: linear-gradient(to right,#c83a2e,#FB9328) ; color:#fff ; font-weight: 600; justify-content: center;align-items: center; font-size: 20px;cursor: pointer">
								立即购买
							</div>


							<div v-if="detailData.status && detailData.status.status_code && detailData.status.status_code == 5 && detailData.price!='0.00'"
								@click="toLogin"
								style="width: 200px;height: 60px;display:inline-flex;background: linear-gradient(to right,#c83a2e,#FB9328) ; color:#fff ; font-weight: 600; justify-content: center;align-items: center; font-size: 20px;cursor: pointer">
								立即购买
							</div>
						</div>
					</div>
				</div>


				<!-- 详情主体内容 -->
				<div class="detail_body">
					<div class="tab_main">
						<div style=" width: 100%; display: flex; justify-content: space-between;">
							<div class="tab_nav_items">
								<div class="tab_nav_item" v-if="detailData.description" @click="changeTab(1)"
									:class="{'actived':tab_index == 1}">
									课程介绍
									<!-- <div class="tab_nav_item_line"></div> -->
								</div>
								<div class="tab_nav_item" @click="changeTab(2)" :class="{'actived':tab_index == 2}">
									课程内容
									<!-- <div class="tab_nav_item_line"></div> -->
								</div>

								<div class="tab_nav_item" v-if="detailData.file_count>0" @click="changeTab(3)"
									:class="{'actived':tab_index == 3}">
									课程资料
									<!-- <div class="tab_nav_item_line"></div> -->
								</div>

								<div class="tab_nav_item" v-if="detailData.notice_count>0" @click="changeTab(4)"
									:class="{'actived':tab_index == 4}">
									培训通知
									<!-- <div class="tab_nav_item_line"></div> -->
								</div>
								
								<div class="tab_nav_item_line" v-if="detailData.description" :style="{'transform':'translateX('+110*(tab_index - 1)+'px)'}"></div>
							</div>

						</div>
						<div class="tab_content_items">

							<!-- 课程介绍 -->
							<div class="tab_content_item" :class="{'actived':tab_index == 1}"
								v-if="detailData.description">
								<div
									style="width: 100%; display: flex; flex-direction: row; justify-content: space-between;">
									<div style="width: 730px; box-sizing: border-box;" v-html="detailData.description">
									</div>
									<div style="width: 330px;  padding:0 0 20px 0; box-sizing: border-box;">
										<div style="display: inline-flex; align-items: center;"
											v-if="detailData.course_toatl!=0">
											<div
												style="display: flex;flex-direction: column; align-items: center;  padding: 0 18px;">
												<div
													style="font-weight: 600; height: 36px; display: flex; align-items: flex-end;">
													<div
														style="font-size: 34px;line-height: 36px; font-family: DINCOND-MEDIUM;">
														{{detailData.course_toatl}}
													</div>
													<div style="font-size: 12px;">门</div>
												</div>
												<div style="font-size: 14px;line-height: 22px;">
													课程数
												</div>
											</div>

											<div style="width: 1px; height: 50px; background-color: #eee;"></div>

											<div
												style="display: flex;flex-direction: column;  align-items: center; padding: 0 18px;">
												<div
													style="font-weight: 600; height: 36px; display: flex; align-items: flex-end;">
													<div
														style="font-size: 34px;line-height: 36px; font-family: DINCOND-MEDIUM;">
														{{detailData.course_toatl_length}}
													</div>
													<div style="font-size: 12px;">分钟</div>
												</div>
												<div style="font-size: 14px;line-height: 22px;">
													总时长
												</div>
											</div>

											<div style="width: 1px; height: 50px; background-color: #eee;"></div>

											<div
												style="display: flex;flex-direction: column; align-items: center; padding: 0 18px;">
												<div
													style="font-weight: 600; height: 36px; display: flex; align-items: flex-end;">
													<div
														style="font-size: 34px;line-height: 36px; font-family: DINCOND-MEDIUM;">
														365
													</div>
													<div style="font-size: 12px;">天</div>
												</div>
												<div style="font-size: 14px; line-height: 22px;">
													服务有效期
												</div>
											</div>
										</div>

										<div style="font-size: 18px; font-weight: 600; margin: 30px 0;">讲师简介</div>
										<div style="display: flex; flex-direction: column;">
											<div style="display: flex;flex-direction: column;line-height: 1.75; margin-bottom: 30px;"
												v-for="(item,index) in teacher_list">
												<div style="display: flex;  align-items: center;">
													<img @click="toDetail(item)" :src="item.img_url_compressed"
														style="width: 66px; height: 66px;background-color: #D3D7F2;  border-radius: 50%;margin-bottom:10px;margin-right: 15px;cursor: pointer;" />
													<div
														style="display: flex; flex-direction: column;margin-top: -15px;">
														<div style="font-size: 18px;">{{item.name}}</div>
														<div
															style="font-size: 14px; display: flex;flex-direction: column;">
															<div v-if="item.title">{{item.title}}</div>
															<div v-if="!item.title && item.job">{{item.job}}</div>
															<div v-if="!item.title && !item.job && item.job2">
																{{item.job2}}</div>
															<div
																v-if="!item.school && !item.college && !item.title && !item.job && item.job3">
																{{item.job3}}</div>
														</div>

													</div>
												</div>
												<div style="font-size: 14px; word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 20; overflow: hidden;text-overflow: ellipsis"
													v-html="item.description"></div>
											</div>

										</div>
									</div>
								</div>
							</div>

							<!-- 课程内容 -->
							<div class="tab_content_item" :class="{'actived':tab_index == 2}">

								<div style="display: flex; flex-direction: column;"
									v-if="!column_list || (column_list && column_list.length==0)">
									<div style="display: flex; flex-direction: column; box-sizing: border-box;">
										<div class="course_list">
											<div class="item" :class="{'item2':tem.product_type == 27}"
												v-for="(tem,dex) in listData.list" @click="toDetail(tem)">
												<div class="item_inner" v-if="tem.product_type == 4">
													<img class="cover" v-lazy="tem.img_url_tt" v-if="tem.img_url_tt" />
													<img class="cover" src="../../assets/images/cover.png"
														v-if="!tem.img_url_tt" />
													<div class="info">
														<div class="title_box">
															<div class="title">{{tem.title}}</div>
															<!-- <div class="author" v-if="tem.author && tem.author!='未知'">主讲人：{{tem.author}}</div> -->
														</div>
														<div class="exts_box">
															<div class="res_info">
																<div class="res_count">{{tem.res_count}}小节</div>
																<div class="res_length"><i
																		class="el-icon-pie-chart icon"></i>{{tem.res_length}}
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="item_inner" v-if="tem.product_type == 27">
													<img class="cover" v-lazy="tem.img_url_tt" v-if="tem.img_url_tt" />
													<img class="cover" src="../../assets/images/cover.png"
														v-if="!tem.img_url_tt" />
												</div>
											</div>
										</div>
									</div>
								</div>



								<div style="display: flex; flex-direction: column;"
									v-if="column_list && column_list.length>0">
									<div class="column_items">
										<div @click="selectedClick(item)" v-for="(item,index) in column_list"
											class="column_item" :class="{'actived':selected && selected.id == item.id}">
											{{item.title.split('：')[0]}}
										</div>
									</div>


									<div style="display: flex; flex-direction: column; box-sizing: border-box;"
										v-for="(item,index) in column_list"
										v-if="selected.id == item.id || selected.id=='0'">
										<div style="margin-top: 30px; display: flex; line-height: 1;"
											v-if="item.list && item.list.length>0">
											<div
												style="margin-right:10px;width:5px; background: linear-gradient(to bottom,#ff9000,#c93a2e); ">
											</div>
											<div style="font-size: 20px;font-weight: 600;">{{item.title}}</div>
										</div>
										<div class="course_list" v-if="item.list && item.list.length>0">
											<div class="item" :class="{'item2':tem.product_type == 27}"
												v-for="(tem,dex) in item.list" @click="toDetail(tem)">
												<div class="item_inner" v-if="tem.product_type == 4">
													<img class="cover" v-lazy="tem.img_url_tt" v-if="tem.img_url_tt" />
													<img class="cover" src="../../assets/images/cover.png"
														v-if="!tem.img_url_tt" />
													<div class="info">
														<div class="title_box">
															<div class="title">{{tem.title}}</div>
															<!-- <div class="author" v-if="tem.author && tem.author!='未知'">主讲人：{{tem.author}}</div> -->
														</div>
														<div class="exts_box">
															<div class="res_info">
																<div class="res_count">{{tem.res_count}}小节</div>
																<div class="res_length"><i
																		class="el-icon-pie-chart icon"></i>{{tem.res_length}}
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="item_inner" v-if="tem.product_type == 27">
													<img class="cover" v-lazy="tem.img_url_tt" v-if="tem.img_url_tt" />
													<img class="cover" src="../../assets/images/cover.png"
														v-if="!tem.img_url_tt" />
												</div>
											</div>
										</div>
									</div>

								</div>
							</div>

							<!-- 课程资料 -->
							<div class="tab_content_item" :class="{'actived':tab_index == 3}"
								v-if="detailData.file_count>0">
								<div style="display: flex; width: 100%; flex-direction: column;min-height: 480px;">
									<div class="res_item" :class="{'cursor':item.is_available==1}" v-for="(item,index) in res_list" @click="downloadClick(item)">
										<div class="info_box">
											<div class="icon_box">
												<i class="iconfont icon-yunxiazai"></i>
											</div>
											<div class="mes_box">
												<div class="title">{{item.file_name}}</div>
												<div class="res_size">文件大小：{{item.file_size}}</div>
											</div>
										</div>
										<div class="from_course" style="font-size: 16px;">所属课程：{{item.course_name}}
										</div>
										<div class="btn_box">
											<div class="btn" v-if="item.is_available == 1">下载</div>
											<div class="msg" v-if="item.is_available == 0" >请购买后再下载</div>
										</div>
									</div>
								</div>

							</div>

							<!-- 培训通知 -->
							<div class="tab_content_item" :class="{'actived':tab_index == 4}"
								v-if="detailData.notice_count>0">
								<div style="display: flex;width: 100%; flex-direction: column;min-height: 480px;">
									<div class="res_item cursor" v-for="(item,index) in detailData.notice_list" @click="downloadClick(item)">
										<div class="info_box">
											<div class="icon_box">
												<i class="iconfont icon-yunxiazai"></i>
											</div>
											<div class="mes_box">
												<div class="title">{{item.file_name}}</div>
												<div class="res_size">文件大小：{{item.file_size}}</div>
											</div>
										</div>
										<div class="from_course" style="font-size: 16px;">&nbsp;</div>
										<div class="btn_box">
											<div class="btn">下载</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";
	import download from 'downloadjs';
	import QRCode from "qrcodejs2";
	
	export default {
		data() {
			return {
				id: null,
				detailData: null,
				column_list: null,
				search: {
					album_id: '',
					product_type: 4,
					page_index: 1,
					page_size: 80,
					order_by: 'created_at:asc'
				},
				listData: {
					total: 1,
					count: 1,
					list: [],
				},
				teacher_list: [],
				res_list: [],
				isLogin: false,
				dialogQrVisible: false,
				qrcode: null,
				qrcode2: null,
				priceShow: true,
				tab_index: 1,
				selected: null,
			};
		},
		components: {
			qrcode: QRCode,
		},
		created() {
			document.title = "课程 - 机工教师特训营";
			this.isLogin = localStorage.getItem("userLogInInfo") ? true : false;
			console.log(this.isLogin);

			var option = {
				id: this.$route.query.id || "",
			};
			if (option.id) {
				this.id = option.id;
				this.search.album_id = option.id;
				this.getDetail();
				this.getResList();
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				if (vm.isMobilePhone()) {
					if (vm.$route.query.path) {
						window.location.href = 'https://m.cmptt.com/pages/album/albumDetails?id=' + vm.$route.query
							.id + '&path=' + vm.$route.query.path;
					} else {
						window.location.href = 'https://m.cmptt.com/pages/album/albumDetails?id=' + vm.$route.query
							.id
					}
				}
			});
		},
		methods: {
			isMobilePhone() {
				const ua = navigator.userAgent.toLowerCase();
				const t1 =
					/android|webos|iphone|ipod|blackberry|iemobile|opera mini|opera mobile|applewebkit.*mobile|mobile/i
					.test(ua);
				return t1;
			},
			downloadClick(item) {
				if(!item.file_path){
					this.$message({
						type: 'info',
						message: '请购买后下载'
					});
					return;
				}
				download(item.file_path, item.file_name);
			},
			changeTab(index) {
				this.tab_index = index;
			},
			selectedClick(item) {
				this.selected = item;
			},
			toTeachRoom() {
				this.GoToDetail(this.detailData.office_info.product_type, this.detailData.office_info.id);
			},
			toLogin() {
				//window.top.location.href = "/login";
				this.$router.push({
					path: '/login'
				});
			},
			showQrClick() {
				if (this.isLogin) {
					this.dialogQrVisible = true;
					var that = this;
					if (!that.qrcode2) {
						that.$nextTick(() => {
							that.setupQrCode(that.$refs.qrcode2, that.detailData.qrcode_url, 150, (code_img) => {
								that.qrcode2 = code_img;
							});
						});
					}
				} else {
					var msg_title = "您需要登录后才可以订阅，是否登录?";
					this.$confirm(msg_title, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						//window.top.location.href = "/login";
						this.$router.push({
							path: '/login'
						});
					}).catch(() => {
						// this.$message({
						// 	type: 'info',
						// 	message: '已取消'
						// });
					});
				}
			},
			finishedClick() {
				this.dialogQrVisible = false;
				this.getResList();
			},

			toDetail(item) {
				if (item.product_type == 4) {
					var url = "/course/detail";
					var query = {
						id: item.id,
						from: this.id
					};
					let routeUrl = this.$router.resolve({
						path: url,
						query: query,
					});
					window.open(routeUrl.href, "_blank");
				} else {
					this.GoToDetail(item.product_type, item.id);
				}
			},

			getDetail() {
				var that = this;
				var url = apiUrl.tt_album_detail_get;
				this.Ajax(url, {
					id: this.id
				}, (data) => {
					that.detailData = data;

					console.log(JSON.stringify(that.detailData))

					that.detailData.qrcode_url = 'http://m.cmptt.com/pages/album/albumDetails?id=' + this.id;
					document.title = data.title + " - 课程 - 机工教师特训营";

					if (that.detailData.description) {
						that.tab_index = 1;
					} else {
						that.tab_index = 2;
					}

					that.$nextTick(() => {
						that.setupQrCode(that.$refs.qrcode, that.detailData.qrcode_url, 120, (
							code_img) => {
							that.qrcode = code_img;
						});
					})

					that.getProductList();
					if (that.detailData.description) {
						that.getTeacherList();
					}

				});
			},
			getProductList() {
				var that = this;
				var url = apiUrl.tt_album_product_list_get;
				this.Ajax(url, this.search, (data) => {
					if (that.listData.total == 0) {
						that.listData.total = data.total;
					}
					if (that.listData.count == 0) {
						that.listData.count = data.count;
					}
					that.listData.list = that.listData.list.concat(data.list);

					if (that.detailData.column_list && that.detailData.column_list.length > 0) {
						that.detailData.column_list.forEach((item, index) => {
							item.list = that.listData.list.filter(i => i.column_id == item.id);
						});
						var list = that.detailData.column_list;
						list.unshift({
							id: 0,
							title: '全部'
						});
						that.column_list = list;
						console.log(JSON.stringify(that.column_list))
						that.selected = list[0];
					}

				});
			},

			getTeacherList() {
				var that = this;
				var url = apiUrl.tt_album_teacher_list_get;
				this.Ajax(url, {
					album_id: this.id,
					page_index: 1,
					page_size: 100,
					order_by: 'created_at:asc'
				}, (data) => {
					that.teacher_list = data.list;
				});
			},

			getResList() {
				var that = this;
				var url = apiUrl.tt_album_res_list_get;
				this.Ajax(url, {
					album_id: this.id,
					page_index: 1,
					page_size: 100,
					order_by: 'created_at:asc'
				}, (data) => {
					that.res_list = data.list;
				});
			},

			//QrCode
			setupQrCode(el, url, width, callback) {
				let code_img = new QRCode(el, {
					width: width,
					height: width, // 高度
					text: url, // 二维码内容
					colorDark: '#333333',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.L,
				});
				if (callback) callback(code_img);
			},

		},
	};
</script>


<style lang="scss">
	.album_detail_container {
		width: 100%;
		min-height: 100vh;
		background: #f1f1f1;

		.detail_body {
			display: flex;
			justify-content: space-between;
			width: 1200px;
			background-color: #fff;
			margin: 30px auto;
			padding: 15px 30px 30px 30px;
			box-sizing: border-box;
			border-radius: 8px;



			.tab_main {
				width: 100%;
				display: flex;
				flex-direction: column;

				.tab_content_items {
					display: flex;
					flex-direction: column;
					margin-top: 28px;

					.tab_content_item {

						display: none;

						&.actived {
							display: flex;
						}


						.res_item {
							width: 100%;
							height: 60px;
							padding: 0 20px;
							box-sizing: border-box;

							display: flex;
							width: 100%;
							flex-direction: row;
							justify-content: space-between;
							align-items: center;
							margin-bottom: 10px;

							&.cursor {
								cursor: pointer;
							}

							.info_box {
								display: flex;

								.icon_box {
									margin-right: 15px;

									.iconfont {
										font-size: 18px !important;
									}
								}

								.mes_box {
									display: flex;
									flex-direction: column;
									justify-content: space-between;


									.title {
										font-size: 18px;
										color: #333;
									}

									.res_size {
										font-size: 10px;
										color: #999;
									}
								}
							}

							.from_course {
								font-size: 18px;
								color: #333;
							}

							.btn_box {
								display: none;

								.btn {
									padding: 12px 42px;
									display: inline-flex;
									font-size: 14px;
									border-radius: 4px;
									color: #fff;
									background: #c83a2e;
								}

								.msg {
									font-size: 16px;
									color: #c83a2e;
								}
							}

							&.res_selected,
							&:hover {
								background-color: #FDF4F3 !important;

								.info_box {
									.icon_box {
										color: #c83a2e !important;
									}

									.mes_box {
										.title {
											color: #c83a2e !important;
										}

										.res_size {
											color: #c83a2e !important;
										}

									}
								}

								.from_course {
									display: none;
								}

								.btn_box {
									display: flex;
								}

							}
						}

						.column_items {
							display: flex;
							flex-wrap: wrap;

							.column_item {
								font-size: 14px;
								line-height: 1;
								color: #333;
								border-radius: 5px;
								margin-right: 20px;
								margin-bottom: 20px;
								cursor: pointer;
								box-sizing: border-box;
								padding: 12px 30px;
								border: 1px solid #DCDFE6;

								&.actived {
									border: 1px solid #FF7A39;
									background-color: #FF7A39;
									color: #fff;
								}
							}
						}

						.course_list {
							display: flex;
							flex-direction: row;
							flex-wrap: wrap;
							margin-top: 20px;


							.item {
								width: 265px;
								height: 252px;
								display: flex;
								flex-direction: column;
								margin-right: 20px;
								margin-bottom: 40px;
								cursor: pointer;
								overflow: hidden;
								border-radius: 0 0 20px 20px;
								box-sizing: border-box;

								&:nth-child(4n+4) {
									margin-right: 0;
								}

								.item_inner {
									display: flex;
									flex-direction: column;
									width: 100%;
									height: 100%;
									margin: 0;
									padding: 0;
									border-radius: 0 0 20px 20px;
									box-sizing: border-box;
								}




								&.item2 {
									width: 548px !important;
									height: 205px !important;
									border: 1px solid #eee;
									border-radius: 20px !important;

									.item_inner {
										border-radius: 20px !important;
									}


									&:nth-child(2n+2) {
										margin-right: 0;
									}
								}



								&:hover {
									box-shadow: -1px 2px 5px 0 rgba(0, 0, 0, 0.1);
									border-radius: 20px;
								}

								.cover {
									width: 100%;
								}


								.info {
									flex: 1;
									background-color: #F1F1F1;
									display: flex;
									flex-direction: column;

									.title_box {
										flex: 1;
										display: flex;
										flex-direction: column;
										padding: 15px 10px 10px 15px;

										.title {
											font-size: 20px;
											font-weight: 600;
											text-align: justify;
											overflow: hidden;
											text-overflow: ellipsis;
											word-break: break-all;
											display: -webkit-box;
											-webkit-box-orient: vertical;
											-webkit-line-clamp: 2;
											line-height: 1.2em;
											max-height: 2.4em;
										}

										.author {
											font-size: 18px;
											line-height: 1;
											margin-top: 8px;
										}
									}

									.exts_box {
										width: 100%;
										height: 40px;
										border-radius: 0 0 20px 20px;
										border-top: 1px solid #E8E8E8;
										display: flex;
										justify-content: space-between;
										align-items: center;
										padding: 0 17px 0 20px;
										box-sizing: border-box;

										.res_info {
											display: flex;
											font-size: 13px;
											align-items: center;

											.res_count {
												background-color: #c93a2e;
												color: #fff;
												padding: 2px 8px;
												border-radius: 20px;
											}

											.res_length {
												margin-left: 8px;

												.icon {
													margin-right: 2px;
												}
											}
										}

										.price_box_s {
											font-weight: 600;
											font-size: 17px;
											color: #c93a2e;
											display: flex;
											line-height: 1;
											align-items: center;

											.label {
												font-size: 10px;
												width: 10px;
												margin-right: 5px;
											}

											.price_box {
												display: flex;
												flex-direction: column;
												font-weight: 600;

												.price {
													font-size: 17px;
													color: #c93a2e;
												}

												.line_price {
													font-size: 10px;
													color: #999;
													text-decoration: line-through;
												}
											}
										}

										.price_n {
											display: flex;
											align-items: center;
											font-weight: 600;
											font-size: 17px;
											color: #c93a2e;
											line-height: 1;
										}


										.price_box_f {
											display: flex;
											align-items: center;
											font-weight: 600;

											.line_price {
												font-size: 16px;
												color: #999;
												margin-right: 5px;
												text-decoration: line-through;
											}

											.text {
												font-size: 17px;
												color: #c93a2e;
											}
										}

										.price_f {
											display: flex;
											align-items: center;
											font-weight: 600;
											font-size: 17px;
											color: #c93a2e;
											line-height: 1;
										}
									}
								}
							}
						}
					}
				}

				.tab_nav_items {
					color: #666;
					height: 50px;
					line-height: 50px;
					font-size: 20px;
					font-weight: 600;
					display: flex;
					position: relative;
					
					.tab_nav_item_line {
						width: 4em;
						height: 2px;
						background-color: #FF7A39;
						position: absolute;
						left: 0;
						top: 45px;
						display: flex;
						transition: transform .3s ease;
					}

					.tab_nav_item {
						display: inline-flex;
						height: 50px;
						line-height: 50px;
						box-sizing: border-box;
						cursor: pointer;
						color: #333;
						position: relative;
						transition: color .3s;

						// .tab_nav_item_line {
						// 	width: 100%;
						// 	height: 2px;
						// 	background-color: #FF7A39;
						// 	position: absolute;
						// 	left: 0;
						// 	top: 45px;
						// 	display: none;
						// 	transition: transform .3s ease;
						// }

						&.actived {
							color: #FF7A39;

							// .tab_nav_item_line {
							// 	display: flex;
							// }
						}
					}

					.tab_nav_item+.tab_nav_item {
						margin-left: 30px;
					}
				}

			}

		}




	}
</style>